"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSTANCE_CHECK_DEFAULT_TEXTS = void 0;
exports.INSTANCE_CHECK_DEFAULT_TEXTS = {
    placeholderIDField: 'Instance ID',
    actionNext: 'Next',
    errorRequired: 'The field is required',
    errorMaxLength: 'The maximum length is {{length}}',
    checkInstanceIdTitle: 'Check instance ID'
};
//# sourceMappingURL=constants.js.map